// Plan v0.3.0 §G-2 (PPTX Slide 7+8) — display helpers for the
// "required fields removed" data layer. After the §G-2 backend
// change, Customer.legalName / Customer.displayName / Robot serial
// fields can be empty strings (the operator skipped them at create).
// The UI must still distinguish those rows in tables and link
// targets, so we render `(미입력 #cust-XXXX)` italic placeholders
// keyed off the row's id prefix.
//
// These helpers are additive — keep this file dependency-free so
// it can be imported from any list / detail page without circular
// trouble.

/**
 * Returns either the customer's display name or a "(미입력 #cust-XXXX)"
 * placeholder when the displayName is missing. The placeholder is
 * keyed off the first 4 characters of the customer's id so operators
 * can still tell rows apart at a glance.
 */
export function customerDisplayLabel(c: { id: string; displayName?: string | null }): string {
  if (c.displayName && c.displayName.trim().length > 0) {
    return c.displayName;
  }
  return `(미입력 #cust-${c.id.slice(0, 4)})`;
}

/**
 * Returns true when a customer's display name is the placeholder
 * fallback. Useful for styling — pages can italic-grey rows where
 * `isCustomerUnnamed(c)` is true.
 */
export function isCustomerUnnamed(c: { displayName?: string | null }): boolean {
  return !c.displayName || c.displayName.trim().length === 0;
}

/**
 * Generic version for any entity that has an id + a primary label
 * field. Lets the same pattern handle robots ("(미입력 #rb-XXXX)"),
 * stores, etc.
 */
export function unnamedFallbackLabel(entityPrefix: string, id: string): string {
  return `(미입력 #${entityPrefix}-${id.slice(0, 4)})`;
}
